// @flow
import React, { useEffect } from 'react';
import { users } from '../services/api/saas';

const unescapeHtml = escapedStr => {
  const div = document.createElement('div');
  div.innerHTML = escapedStr;
  const child = div.childNodes[0];
  return child ? child.nodeValue : null;
};

const validateProtocol = url => {
  const parser = document.createElement('a');
  parser.href = url;
  const protocol = parser.protocol.toLowerCase();
  if (
    // eslint-disable-next-line no-script-url
    ['javascript:', 'vbscript:', 'data:', 'ftp:', ':', ' '].indexOf(protocol) < 0
  ) {
    return url;
  }
  return null;
};

const validate = url => {
  const unescapedValue = unescapeHtml(url);
  if (unescapedValue && validateProtocol(unescapedValue)) {
    return unescapedValue;
  }
  return '/';
};

export default ({
  desktopAppInstalledOrNot,
  deeplink,
  newUser,
}: {
  desktopAppInstalledOrNot: Function,
  deeplink?: string,
  newUser?: boolean,
}) => {
  useEffect(() => {
    const doEffect = async () => {
      let hasURI = false;
      let intervalExecuted = false;
      const iframe = document.getElementById('desktop-app-checker');
      let firebaseCustomToken;
      try {
        firebaseCustomToken = await users.fetchCustomToken();
      } catch (e) {
        // If an error happens, we're just not trying to keep the user logged in.
      }
      let link = 'ava.me://open';
      if (firebaseCustomToken) {
        link = `${link}/web?firebaseCustomToken=${firebaseCustomToken}`;
        console.log(`Trying to launch Ava CC with: ${link}`);
        if (newUser) {
          link += '&newUser=true';
        }
      }
      // $FlowFixMe
      iframe.src = validate(deeplink || link);
      window.setTimeout(() => {
        if (!hasURI) {
          desktopAppInstalledOrNot(false);
        } else {
          desktopAppInstalledOrNot(true);
        }
        intervalExecuted = true;
      }, 300);

      let reset;

      const onBlur = () => {
        hasURI = true;
      };

      const onFocus = () => {
        reset();
        if (!hasURI && intervalExecuted) {
          desktopAppInstalledOrNot(false);
        } else if (hasURI) {
          desktopAppInstalledOrNot(true);
        }
      };

      reset = () => {
        window.removeEventListener('focus', onFocus);
        window.removeEventListener('blur', onBlur);
      };

      window.addEventListener('focus', onFocus);
      window.addEventListener('blur', onBlur);
    };
    doEffect();
  }, []);
  return (
    <div>
      <iframe
        id="desktop-app-checker"
        title="desktop-app-checker"
        width="1"
        height="1"
        style={{ visibility: 'hidden' }}
      />
    </div>
  );
};
